import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FloatingArrowModule } from '@app/content/shared/floating-arrow/floating-arrow.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DropdownModule } from '../directives/dropdown/dropdown.module';
import { InsurancesDropdownModule } from './insurances-dropdown/insurances-dropdown.module';
import { InsurancesListModule } from './insurances-list/insurances-list.module';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        LazyLoadImageModule,
        FloatingArrowModule,
        RouterModule,
        ListModule,
        DropdownModule,
        InsurancesDropdownModule,
        InsurancesListModule,
    ],
    exports: [
        InsurancesDropdownModule,
        InsurancesListModule,
    ],
})
export class InsuranceModule {
}
